import React from 'react';
import DeployExternalServicesSettings from './DeployExternalServicesSettings';

export default function DeploySettings() {
    return <DeployExternalServicesSettings />;
}
